import { getFilterDisplayName } from 'constants/report-filters-mapping';

export interface FavoriteReportFilter {
  column: string;
  values: unknown[];
  [key: string]: unknown;
}

interface FilterItemProps {
  filter: FavoriteReportFilter;
}

const FilterItem = ({ filter }: FilterItemProps): React.JSX.Element => {
  const formatFilterValue = (values: unknown[] | undefined): string => {
    if (!Array.isArray(values) || values.length === 0) {
      return 'No value';
    }

    return values.join(', ');
  };

  return (
    <div className="w-fit inline-block border border-navy-200 rounded px-2 py-1 text-sm text-gray-500">
      {getFilterDisplayName(filter.column)}: {formatFilterValue(filter.values)}
    </div>
  );
};

export default FilterItem;
